import { DisplayColorEnum } from "@propertelligent/client-api";


const displayColorMap: Record<DisplayColorEnum, string> = {
  [DisplayColorEnum.Default]: "var(--color-default)",
  [DisplayColorEnum.Success]: "var(--color-success)",
  [DisplayColorEnum.Info]: "var(--color-info)",
  [DisplayColorEnum.Warning]: "var(--color-warning)",
  [DisplayColorEnum.Danger]: "var(--color-danger)",
};
export default displayColorMap;
